import * as ScrollAreaPrimitive from '@radix-ui/react-scroll-area';
import type { ComponentProps } from 'react';

import { cn } from '@/lib/utils.js';

export function ScrollArea({
  className,
  children,
  ...props
}: ComponentProps<typeof ScrollAreaPrimitive.Root>): React.ReactNode {
  return (
    <ScrollAreaPrimitive.Root
      data-slot="scroll-area"
      className={cn('group/scroll-area relative overflow-hidden', className)}
      {...props}
    >
      <ScrollAreaPrimitive.Viewport
        data-slot="scroll-area-viewport"
        className="size-full rounded-[inherit] overscroll-contain focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring [&>div]:!block"
      >
        {children}
      </ScrollAreaPrimitive.Viewport>
      <ScrollBar />
      <ScrollAreaPrimitive.Corner />
    </ScrollAreaPrimitive.Root>
  );
}

export function ScrollBar({
  className,
  orientation = 'vertical',
  ...props
}: ComponentProps<
  typeof ScrollAreaPrimitive.ScrollAreaScrollbar
>): React.ReactNode {
  return (
    <ScrollAreaPrimitive.ScrollAreaScrollbar
      data-slot="scroll-area-scrollbar"
      orientation={orientation}
      className={cn(
        'flex touch-none select-none opacity-0 transition-opacity duration-200 hover:opacity-100 data-[state=visible]:opacity-100 group-hover/scroll-area:opacity-100',
        orientation === 'vertical' && 'h-full w-2 p-px',
        orientation === 'horizontal' && 'h-2 w-full flex-col p-px',
        className,
      )}
      {...props}
    >
      <ScrollAreaPrimitive.ScrollAreaThumb
        data-slot="scroll-area-thumb"
        className="relative flex-1 rounded-full bg-border hover:bg-foreground/30"
      />
    </ScrollAreaPrimitive.ScrollAreaScrollbar>
  );
}
